var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_2178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8.73V10.25C2 10.39 2.11 10.5 2.25 10.5H3.77C3.835 10.5 3.9 10.475 3.945 10.425L9.405 4.97L7.53 3.095L2.075 8.55C2.025 8.6 2 8.66 2 8.73ZM10.855 3.52C11.05 3.325 11.05 3.01 10.855 2.815L9.685 1.645C9.49 1.45 9.175 1.45 8.98 1.645L8.065 2.56L9.94 4.435L10.855 3.52Z",
    fill: "#407BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_2178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.58ee098d753d066051c8e9f2c1f7ce0c.svg";
export { ForwardRef as ReactComponent };